<!--
 * @Description: 模板单项组件
 * @Autor: WangYuan
 * @Date: 2021-05-31 11:55:13
 * @LastEditors: WangYuan
 * @LastEditTime: 2022-01-27 19:43:23
-->
<template>
  <el-tooltip class="item" effect="light" :content="label" placement="bottom" :open-delay="200" :disabled="label == ''">
    <div>
      <div v-if="!img" class="mode-select-item flex-center"
        :class="[value == mode.mValue ? 'mode-select-item-active' : '']" @click="clickItem">
        <i v-if="icon" class="icon f20" :class="icon"></i>
        <span v-else>{{ label }}</span>
      </div>
      <div class="mode-select-item_img flex-center" :class="[value == mode.mValue ? 'mode-select-item_img-active' : '']"
        @click="clickItem">
        <img style="width: 28px;" :src="img" :title="mode.mTooltip"/>
      </div>
     <div v-if="shouldShowChildList" class="child-list-container">
        <img v-for="(item, index) in childList" :key="item.id || index" 
             :src="item.img" style="width: 56px;height: 56px; margin-right: 8px;">
      </div>
    </div>
  </el-tooltip>
</template>

<script>
export default {
  name: 'select-item',

  props: ['label', 'value', 'icon', 'img', 'ctrl', 'child'],

  inject: ['mode'],
  data() {
    return {
      childList: [],
      showChildList: false
    };
  },
  computed: {
    shouldShowChildList() {
      return this.showChildList && this.childList.length > 0;
    }
  },
    watch: {
    'mode.mValue'(newVal) {
      this.showChildList = newVal === this.value;
      if (this.showChildList) {
        this.childList = this.child || [];
      }
    }
  },
  created() {
    if (this.mode.mValue === this.value) {
      this.showChildList = true;
      this.childList = this.child || [];
    }
  },
  methods: {
    clickItem() {
      this.$parent.$children.forEach(sibling => {
        if (sibling !== this && sibling.$options.name === 'select-item') {
          sibling.showChildList = false;
        }
      });
      
      this.childList = this.child || [];
      this.mode.mValue = this.value;
      this.mode.mTooltip = this.label;
      this.showChildList = true;
      this.$emit('custom-event', this);
      this.$emit('child-list-length-changed', this.childList.length);
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../scss/variable";
@import "../iconfont-designer.css";
.child-list-container {
  position: absolute;
  top: 30px;
  left: 0;
}
.mode-select-item {
  padding: 8px 10px;
  width: 28px;
  border: 1px solid #dcdee0;
  /*no*/
  border-radius: 0;
  border-color: #ebedf0;
  font-size: 12px;
  /*no*/
  font-weight: 500;
  text-align: center;
  cursor: pointer;

  &:hover {
    color: $color-theme;
    border-color: $color-theme;
    background-color: #e0edff;

    i {
      color: $color-theme;
    }
  }

  i {
    color: #979797;
  }
}

.mode-select-item_img {
  width: 28px;
  border: 1px solid #dcdee0;
  border-radius: 0;
  border-color: #ebedf0;
  font-size: 12px;
  font-weight: 500;
  text-align: center;

  margin-right: 15px;
  border-radius: 5px;
  cursor: pointer;

  i {
    color: #979797;
  }
}

.mode-select-item_img-active {
  color: $color-theme;
  border-color: $color-theme;
  background-color: #eeeef0;

  i {
    color: $color-theme;
  }
}

.mode-select-item-active {
  color: $color-theme;
  border-color: $color-theme;
  background-color: #e0edff;

  i {
    color: $color-theme;
  }
}
</style>
